import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { alpha, IconButton, type Theme } from '@mui/material';
import type { MouseEventHandler } from 'react';
import UnreadMessagesBadge from '../../../atoms/UnreadMessagesBadge';

const styles = {
  button: (isOpen: boolean) => (theme: Theme) => ({
    width: 40,
    height: 40,
    borderRadius: 2.5,
    border: '1px solid',
    borderColor: isOpen ? alpha(theme.palette.primary.main, 0.28) : 'neutral.A100',
    backgroundColor: isOpen ? alpha(theme.palette.primary.main, 0.12) : 'neutral.600',
    color: isOpen ? 'primary.main' : 'text.primary',
    '&:hover': {
      backgroundColor: 'neutral.500',
    },
    '& svg': {
      fontSize: 20,
    },
  }),
} as const;

type NeobetAccountMenuButtonProps = {
  isOpen?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  showUnreadBadge?: boolean;
};

const NeobetAccountMenuButton = ({
  isOpen = false,
  onClick,
  showUnreadBadge = false,
}: NeobetAccountMenuButtonProps) => {
  const icon = <PersonRoundedIcon />;

  return (
    <IconButton data-testid='neobet-account-menu-button' onClick={onClick} sx={styles.button(isOpen)}>
      {showUnreadBadge ? <UnreadMessagesBadge>{icon}</UnreadMessagesBadge> : icon}
    </IconButton>
  );
};

export default NeobetAccountMenuButton;
